import React from 'react';

import { NumericTextInput, NumericTextInputProps } from '@/components/form-controls/numeric-text-input';

export const CurrencyTextInput = ({ ...props }: NumericTextInputProps) => {
  return <NumericTextInput {...props} />;
};
